import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { PermissionAdmin } from '../models/admin.permission.model';
import { PermissionAppointments } from '../models/appointment.permission.model';
import { CheckPermissionGroupName } from '../models/CheckPeermissionGroup';
import { PermissionLobby } from '../models/lobby.permission.model';
import { PermissionGroupAddModel } from '../models/permission.add.model';
import { PermissionGridRequestModel } from '../models/permission.grid.request.model';
import { PermissionUpdate } from '../models/permission.update.model';
import { PermissionReport } from '../models/report.permission.model';
import { IPermissionGrid } from '../models/permission-grid';
@Injectable({
  providedIn: 'root'
})
export class PermissionsServiceService {

  private baseUrl: string = '';
  private appConfig!: AppConfigurations;
  private permissionController: string = '';
  public edittingPermission: any;
  public adminPermissions: PermissionAdmin = new PermissionAdmin();
  public lobbyPermissions: PermissionLobby = new PermissionLobby();
  public reportPermissions: PermissionReport = new PermissionReport();
  public appointmentPermissions: PermissionAppointments = new PermissionAppointments();
  private orchestratorBaseApi: string = '';
  private orchestratorPermissionApi: string = '';

  constructor(private appInitService: AppInitService, private http: HttpClient) {
    this.appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }

  setAdminPermission(permission: PermissionAdmin) {
    this.adminPermissions = permission;
  }

  getAdminPermission() {
    return this.adminPermissions
  }

  setLobbyPermission(lobbyPermission: PermissionLobby) {
    this.lobbyPermissions = lobbyPermission;
  }

  getLobbyPermission() {
    return this.lobbyPermissions
  }

  setReportPermission(reportPermission: PermissionReport) {
    this.reportPermissions = reportPermission;
  }

  getReportPermission() {
    return this.reportPermissions
  }

  setAppointmentPermission(appointmentPermissions: PermissionAppointments) {
    this.appointmentPermissions = appointmentPermissions;
  }

  getAppointmentPermission() {
    return this.appointmentPermissions
  }

  /*
  Set editting permission category
   @returns permissionCategory
  */
  setEdittingPermissionCategory(permissionCategory: any) {
    this.edittingPermission = permissionCategory;
  }

  /**
   * Returns editing permission
   * @returns edittingPermission
   */
  getEdittingPermissionCategory() {
    return of(this.edittingPermission)
  }


  /**
   * 
   * @param permissionGridRequest 
   * @returns 
   */
  getDataForPermissionGrid(permissionGridRequest: PermissionGridRequestModel): Observable<IPermissionGrid<any>> {
    let url = `${this.baseUrl}${this.permissionController}?sortInfo.sortColumn=${permissionGridRequest.SortInfo.SortColumn}&sortInfo.sortDirection=${permissionGridRequest.SortInfo.sortDirection}
    &pageInfo.page=${permissionGridRequest.PageInfo.Page}
    &pageInfo.pageSize=${permissionGridRequest.PageInfo.PageSize}
    &searchText=${permissionGridRequest.SearchText}`;   
    return this.http.get<IPermissionGrid<any>>(url);
  }

  /**
   * 
   * @param permission 
   * @returns 
   */
  checkForPermissionGroupNameAlreadyExsists(permission :CheckPermissionGroupName): Observable<any> {
    let url = `${this.baseUrl}${this.permissionController}/existinggroup/${permission.permissionName}?id=${permission.permissionId}&isNotification=${permission.isNotification}`;
    return this.http.get<any>(url);
  }

  /**
   * Update permission group
   * @param permission 
   * @returns 
   */
  submitUpdatedPermissions(permissionUpdate: PermissionUpdate): Observable<any> {
    let url = `${this.baseUrl}${this.permissionController}`;
    return this.http.put(url, permissionUpdate);
  }


  /**
   * 
   * @param permissionCreate 
   * @returns 
   */
  createPermissionsGroups(permissionCreate: PermissionGroupAddModel): Observable<any> {
    let url = `${this.baseUrl}${this.permissionController}`;
    return this.http.post(url, permissionCreate);
  }

  /**
   * 
   * @param getPermissionByGroupId 
   * @returns 
   */
  getPermissionByGroupId(permissionGroupInfo: any): Observable<any> {
    let url = `${this.baseUrl}${this.permissionController}/${permissionGroupInfo.permissionGroupId}/permissions?isNotificationGroup=${permissionGroupInfo.notificationGroup}`;
    return this.http.get(url);
  }

  /**
 * 
 * @param getPermissionByGroupId 
 * @returns 
 */
  getAllPermissions(): Observable<any> {
    let url = `${this.baseUrl}${this.permissionController}/all-permissions`;
    return this.http.get(url);
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.adminApi.baseApiUrl;
    this.permissionController = this.appConfig.adminApi.permissionController;
    this.orchestratorBaseApi = this.appConfig.orchestratorApi.baseApiUrl;
    this.orchestratorPermissionApi = this.appConfig.orchestratorApi.permissionController;
  }
  checkDeletionPermissionGroupEligibility(groupId: number, isPermissionGroup: boolean): Observable<any> {
    let url = `${this.baseUrl}${this.permissionController}/permissionGroupDeleteValidaion/${groupId}/${isPermissionGroup}`;
    return this.http.get(url);
  }
  deleteGroup(groupId: number, isPermissionGroup: boolean): Observable<any> {
    let url = `${this.orchestratorBaseApi}${this.orchestratorPermissionApi}/${groupId}?isPermissionGroup=${isPermissionGroup}`;
    return this.http.delete(url);
  }

}
